import React, { Component } from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
//import Result from './Result';
import { handleSubmitQuery } from '../actions/query';
import queryString from 'query-string';

import SearchList from './SearchList';


class Search extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMore: false,
      page: 0,
      sort_by: 'year_desc',
      filter_strings: {}
    }
  }

  componentDidMount() {
    const query = queryString.parse(this.props.location.search)['q'];
    this.performSearch(query);
  }

  componentWillReceiveProps(nextProps) {
    const query = queryString.parse(nextProps.location.search)['q'];
    if(query !== this.props.query) {
      this.setState({
        filter_strings: {},
        sort_by: 'year_desc'
      }, () => {
        this.performSearch(query);
      });
    }
  }

  buildSearchParams = () => {
    let params = [];
    // String zur Sortierung
    if(this.state.sort_by !== ''){
      params.push('sort='+this.state.sort_by);
    }
    // Parameter für Filterung
    for (var key in this.state.filter_strings) {
      var value = this.state.filter_strings[key];
      if(value instanceof Array) {
        for (var arrayItem of value){
          params.push(key+'='+arrayItem);
        }
      } else if (value instanceof Object) {
        for (var objectItem in value){
          params.push(key+'_'+objectItem+'='+value[objectItem]);
        }
      }
    }
    return params;
  }

  performSearch = (query) => {
    this.setState({
      loading: true,
      page: 0,
    });

    const params = this.buildSearchParams();

    this.props.dispatch(handleSubmitQuery(query, params))
      .then(() => {
        this.setState({
          loading: false
        })
      }
    );
  }

  toggleFilter = (value, key) => {
    const query = queryString.parse(this.props.location.search)['q'];
    this.setState({
      filter_strings: {
        ...this.state.filter_strings,
        [key]: value
      }
    }, () => {
      this.performSearch(query);
    });
  }

  changeOrder = (type) => {
    const query = queryString.parse(this.props.location.search)['q'];
    if(type !== this.state.sort_by){
      this.setState({
        sort_by: type
      }, () => {
        this.performSearch(query);
      });
    }
  }

  loadMoreResults = () => {
    //const query = this.props.query;
    const query = queryString.parse(this.props.location.search)['q'];
    const params = this.buildSearchParams();
    params.push('page='+(this.state.page+1));
    this.setState({
      loadingMore: true,
      page: this.state.page+1
    })
    this.props.dispatch(handleSubmitQuery(query, params, true))
      .then(() => {
        this.setState({
          loadingMore: false,
        })
      }
    );
  }

  render() {
    return (
      <div className='d-flex flex-column' style={{flex: 1}}>
        <React.Fragment>
          <SearchList
            loadMoreResults={this.loadMoreResults}
            changeOrder={this.changeOrder}
            toggleFilter={this.toggleFilter}
            {...this.props}
            {...this.state}
          />
        </React.Fragment>
      </div>
    )
  }
}

function mapStateToProps(state, props) {
  return {
    ...props,
    query: state.query,
    results: state.results,
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps)
)(Search);



// WEBPACK FOOTER //
// ./src/components/Search.js